import React from 'react';
import Hero from '../components/Hero/Hero';
import LatestProperties from '../components/LatestProperties/LatestProperties';
import FaqSection from '../components/FaqSection/FaqSection'
import 'bootstrap/dist/css/bootstrap.min.css';

function Index() {
  return (
    <div>
      <Hero/>
      <LatestProperties/>
      <FaqSection/>
    </div>
  );
}

export default Index;